import { render, staticRenderFns } from "./EntrustFlow.vue?vue&type=template&id=3cbfa85e&scoped=true"
import script from "./EntrustFlow.vue?vue&type=script&lang=js"
export * from "./EntrustFlow.vue?vue&type=script&lang=js"
import style0 from "./EntrustFlow.vue?vue&type=style&index=0&id=3cbfa85e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbfa85e",
  null
  
)

export default component.exports